import { render } from "./NonResizableOnOverflow.vue?vue&type=template&id=4cbe2a8e"
import script from "./NonResizableOnOverflow.vue?vue&type=script&lang=js"
export * from "./NonResizableOnOverflow.vue?vue&type=script&lang=js"

import "./NonResizableOnOverflow.vue?vue&type=style&index=0&id=4cbe2a8e&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__